module.exports = __webpack_public_path__ + "media/images/icons/flags/ES-ab4d328ed6c9d4317b644e1e6dc5bd14.svg";